module.exports = __webpack_public_path__ + "static/media/Project-Information.ffc456ca.svg";